import Styled, { css } from 'styled-components';

import { RadioGroup } from '../RadioInputs/RadioGroup/RadioGroup.style';
import { cssDeclaration, VALID_EDGE_STYLE_DATA, VALID_MEDIA_STYLES } from '../../Utils';
import { FormError } from '../FormStyles';

import { IFieldSetCommonProps } from './common';

interface IStyledFieldSetProps  extends IFieldSetCommonProps {
  marginProp?: VALID_EDGE_STYLE_DATA;
  orderProp?: VALID_MEDIA_STYLES;
  isRadioCard?: boolean;
}

export const FieldSet = Styled.fieldset<IStyledFieldSetProps>`
  ${({
    theme: { themeTwo },
    alignSelf,
    flexBasis,
    flexGrow,
    flexShrink,
    marginProp,
    orderProp,
    isRadioCard,
  }) => {
    const { global, form: { radio: { card }}} = themeTwo;

    return css`
      /* margin */ ${cssDeclaration(themeTwo, 'margin', marginProp)};
      /* align-self */ ${alignSelf && cssDeclaration(themeTwo, 'align-self', alignSelf)};
      /* flex-basis */ ${flexBasis && cssDeclaration(themeTwo, 'flex-basis', flexBasis)};
      /* flex-grow */ ${flexGrow && cssDeclaration(themeTwo, 'flex-grow', flexGrow)};
      /* flex-shrink */ ${flexShrink && cssDeclaration(themeTwo, 'flex-shrink', flexShrink)};
      /* order */ ${orderProp && cssDeclaration(themeTwo, 'order', orderProp)};

      ${isRadioCard && css`
        ${RadioGroup} {
          & + ${FormError} {
            // zeros ml if theme requires error indention for checkboxes and radios
            margin-left: 0;
            margin-top: ${global.edgeSize[card.state.error.text.margin.top] || card.state.error.text.margin.top};
          }
        }
      `}
    `;
  }}
`;
